import React from 'react';
import './recentBlogs.css';
import {Link} from "react-router-dom";
import {Row, Col, Image} from "react-bootstrap";
import useHandleRequest from "../../../custom_hooks/useHandleRequest";

function RecentBlogs({blogs= [], isBlog = true}) {
    const {handleRequestAndNavigate} = useHandleRequest();

    return (
        <div className={'recent-blogs'}>
            <p className={'header'}>جدیدترین‌ها</p>
            <hr/>
            {isBlog ?

                    blogs.map((blog, index) => (
                        <div key={index} className={'recent-blog-row mb-4'}>
                            <div className={'image-wrapper'}>
                                <Image src={blog.thumbnail} fluid/>
                            </div>
                            <div className={'content-wrapper'}>
                                <h5>
                                    <Link to={`/blogs/${blog.id}`}>{blog.title}</Link>
                                </h5>
                                <p>{blog.publication_date}</p>
                            </div>
                        </div>
                    ))

                :

                blogs.map((blog, index) => (
                    <div key={index} className={'recent-blog-row mb-4'}>
                        <div className={'image-wrapper'}>
                            <Image src={blog.logo} fluid/>
                        </div>
                        <div className={'content-wrapper'}>
                            <h5>
                                <Link to={`/project/${blog.id}`} onClick={(e) => handleRequestAndNavigate(e, `/project/${blog.id}`, `/project/${blog.id}`, 'project')} >{blog.title}</Link>
                            </h5>
                            <p>{blog.completion_date}</p>
                        </div>
                    </div>
                ))

            }
        </div>
    );
}

export default RecentBlogs;
